<template>
  <aha-antd-button
    class="new-folder-button"
    variant="secondary"
    size="lg"
    @click="onNewFolderButtonClicked"
    v-aha-emit-action
    name="presentation-list-new-folder-button"
    v-tooltip="$i18nPresenter.t('New folder')"
  >
    <aha-icon
      name="folder-simple-plus"
      width="16"
      height="16"
      viewBox="0 0 17 17"
      maintainColor
      class="new-folder-button-icon"
    />
    <span class="new-folder-button-text">
      {{ $i18nPresenter.t("New folder") }}
    </span>
  </aha-antd-button>
</template>

<script>
export default {
  name: 'NewFolderButtonV2',

  methods: {
    onNewFolderButtonClicked() {
      this.$emit('handleClickCreateNew', 'folder')
    },
  },
}
</script>

<style lang="scss" scoped>
.new-folder-button {
  @apply text-base font-normal text-gray-100;
  &:deep(.--content-container) {
    @apply flex items-center gap-2;
  }
  svg.new-folder-button-icon {
    &:deep(path) {
      stroke: var(--color-gray-90, #4A4A4A);
    }
  }
  &:hover {
    svg.new-folder-button-icon {
      &:deep(path) {
        stroke: var(--color-primary, #6A1EBB);
      }
    }
  }
}
</style>
